// Preserve server-rendered collection/manual cards if Shopify's fallback fails.
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-sharifco-recommendations]').forEach(async (root) => {
      if (root.dataset.needsFallback !== 'true' || root.dataset.loading === 'true') return;
      root.dataset.loading = 'true';
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(root.dataset.url, window.location.origin);
        url.searchParams.set('product_id', root.dataset.productId);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('intent', 'related');
        url.searchParams.set('limit', '10');
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(`Recommendations returned ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.getElementById(root.id)?.querySelector('[data-related-content]');
        const content = root.querySelector('[data-related-content]');
        // Never replace useful existing content with a failed/empty response.
        if (root.isConnected && replacement?.querySelector('.sharifco-related-card') && content) {
          content.replaceChildren(...replacement.childNodes);
        }
      } catch (error) {
        root.dataset.fallbackFailed = 'true';
        console.warn('Sharifco recommendations: keeping existing collection products.', error.message);
      } finally {
        window.clearTimeout(timeout);
        root.dataset.loading = 'false';
        root.dataset.needsFallback = 'false';
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
